/* eslint-disable no-shadow */
var ProductType;
(function (ProductType) {
    ProductType["Product"] = "Product";
    ProductType["Bundle"] = "Bundle";
    ProductType["Accessory"] = "Accessory";
})(ProductType || (ProductType = {}));
var ProductOrigin;
(function (ProductOrigin) {
    ProductOrigin["LEID_SMART"] = "LEID_SMART";
    ProductOrigin["FRANCHISEE"] = "FRANCHISEE";
    ProductOrigin["SAAS"] = "SAAS";
})(ProductOrigin || (ProductOrigin = {}));
var ProductUsage;
(function (ProductUsage) {
    ProductUsage["REGULAR"] = "REGULAR";
    ProductUsage["CONSUMABLE"] = "CONSUMABLE";
    ProductUsage["SERVICE"] = "SERVICE";
})(ProductUsage || (ProductUsage = {}));
var UsageType;
(function (UsageType) {
    UsageType["FRONT"] = "FRONT";
    UsageType["END"] = "END";
    UsageType["ENTIRE"] = "ENTIRE";
})(UsageType || (UsageType = {}));
var ProductCategoryType;
(function (ProductCategoryType) {
    ProductCategoryType["PRODUCTS"] = "PRODUCTS";
    ProductCategoryType["FUNCTIONS"] = "FUNCTIONS";
})(ProductCategoryType || (ProductCategoryType = {}));
var ProductInfoType;
(function (ProductInfoType) {
    ProductInfoType["VIDEO_URL"] = "VIDEO_URL";
    ProductInfoType["DOCUMENT_URL"] = "DOCUMENT_URL";
    ProductInfoType["ARTICLE_ID"] = "ARTICLE_ID";
    ProductInfoType["USER_MANUAL"] = "USER_MANUAL";
    ProductInfoType["IMAGE_URL"] = "IMAGE_URL";
    ProductInfoType["TEXT"] = "TEXT";
})(ProductInfoType || (ProductInfoType = {}));
var ProductInfoFunction;
(function (ProductInfoFunction) {
    ProductInfoFunction["USER_MANUAL"] = "USER_MANUAL";
    ProductInfoFunction["PICKUP_INSTRUCTIONS"] = "PICKUP_INSTRUCTIONS";
    ProductInfoFunction["GENERIC"] = "GENERIC";
})(ProductInfoFunction || (ProductInfoFunction = {}));

export { ProductCategoryType, ProductInfoFunction, ProductInfoType, ProductOrigin, ProductType, ProductUsage, UsageType };
//# sourceMappingURL=enums.js.map
